/* eslint-disable max-len */
import styled from 'styled-components';
import CircleRingIconDark from '../../assets/images/circle-ring-icon.svg';

const ForgotPasswordCircleRingIcon = styled.span`
  background: url(\"${CircleRingIconDark}\") no-repeat left center;
  background-size: 24px 24px;
  display: inline-block;
  position: relative;
  width: 24px;
  height: 24px;
`;

export default ForgotPasswordCircleRingIcon;
